import { util as ForgeUtil } from 'node-forge';
export const createBase64RsaCrypto = (crypto) => {
    return new NodeForgeBase64RsaCrypto(crypto);
};
class NodeForgeBase64RsaCrypto {
    crypto;
    constructor(crypto) {
        this.crypto = crypto;
    }
    encrypt(unencrypted) {
        const data = this.crypto.encrypt(unencrypted);
        return ForgeUtil.binary.base64.encode(data);
    }
    decrypt(encrypted) {
        const decoded = ForgeUtil.binary.base64.decode(encrypted);
        return this.crypto.decrypt(decoded);
    }
    encryptLong(unencrypted) {
        const dataBlocks = this.crypto.encryptLong(unencrypted);
        return dataBlocks.map((block) => ForgeUtil.binary.base64.encode(block));
    }
    decryptLong(encrypted) {
        const dataBlocks = encrypted.map((encryptedBlock) => ForgeUtil.binary.base64.decode(encryptedBlock));
        return this.crypto.decryptLong(dataBlocks);
    }
}
